import { PowerGlitch } from 'powerglitch';

//Cookie helper functions
function setCookie(name, value, days = 365) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}

function getCookie(name) {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let c = cookies[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
    }
    return null;
}

function deleteCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}

//Store event handlers so we can remove them later (must be declared early)
const glitchEventHandlers = new WeakMap();

//Get all bugs
const bugs = document.querySelectorAll('.bug');
const bag = document.querySelector('.collectible_bag');
const collectedBugs = JSON.parse(getCookie('collectedBugs') || '[]');
const filterOverlay = document.querySelector('.filter_overlay');
const maxBugs = bag ? bag.getAttribute('data-max-bugs') : 0;

const collectibleCountElem = document.querySelector('[data-behaviour="collectible_count"]');
let collectedBugCount = 0;
const totalBugs = collectibleCountElem ? parseInt(collectibleCountElem.textContent.split('/')[1].trim()) : 0;


//rotate all bugs randomly
bugs.forEach(bug => {
    //Get bug_wrap to rotate only the bug body and legs
    const bugWrap = bug.querySelector('.bug_wrap');
    const bugRotator = bug.querySelector('.bug_rotator');

    //Set random rotation angle
    const randomAngle = Math.floor(Math.random() * 360);
    bugRotator.style.transform = `rotate(${randomAngle}deg)`;

    //Add click event listener
    bug.addEventListener('click', onBugClick);

    //Count all collected bugs from localstorage and hide them when they are on this page
    const bugHash = bug.getAttribute('data-bughash');
    if (collectedBugs.includes(bugHash)) {
        //If collected, remove the bug from the DOM
        bug.remove();
        updateCollectibleCount();
    } else {
        bug.classList.add('visible');
    }
});

//Add all collected bugs to the count
collectedBugCount = collectedBugs.length;

//Initial update of collectible count
updateCollectibleCount();

//Function to handle bug click
function onBugClick(event) {
    const bug = event.currentTarget;

    //Animate the bugs towards the bag when clicked
    animateBugToBag(bug);
}

function animateBugToBag(bug) {
    //Animate bag collecting the bug
    bag.classList.add('visible');

    //Get the position of the bag and the bug but calculate the bag a little higher to simulate dropping into the bag
    const bagRect = bag.getBoundingClientRect();
    const bugRect = bug.getBoundingClientRect();

    const deltaX = bagRect.left + bagRect.width / 2 - (bugRect.left + bugRect.width / 2);
    const deltaY = bagRect.top + bagRect.height / 2 - 150 - (bugRect.top + bugRect.height / 2);

    bug.style.transition = 'transform 1s ease-in-out, opacity 1s ease-in-out';
    bug.style.transform += ` translate(${deltaX}px, ${deltaY}px) scale(0.1) rotate(720deg)`;
    bug.style.opacity = '0';

    //After animation ends, remove the bug and update count
    bug.addEventListener('transitionend', () => {
        bug.remove();
        collectedBugCount++;
        wiggleBag();
        saveCollectedBug(bug);
        updateCollectibleCount();
        setTimeout(() => {
            bag.classList.remove('visible');
        }, 500);
    }, { once: true });
}

function updateCollectibleCount() {
    if (collectibleCountElem) {
        collectibleCountElem.textContent = `${collectedBugCount} / ${totalBugs}`;
    }
    if(collectedBugCount >= maxBugs) {
        filterOverlay.classList.add('invisible');
        finishBugHunt();
        removeAllGlitchEffects();
    } else {
        filterOverlay.classList.remove('invisible');
    }
}

function wiggleBag() {
    //Wiggle bag when a bug is collected
    bag.classList.add('wiggle');
    setTimeout(() => {
        bag.classList.remove('wiggle');
    }, 500);
}

function saveCollectedBug(bug) {
    //When a bug is collected, save the bughash to the cookie
    let collectedBugs = JSON.parse(getCookie('collectedBugs') || '[]');
    const bugHash = bug.getAttribute('data-bughash');
    if (!collectedBugs.includes(bugHash)) {
        collectedBugs.push(bugHash);
        setCookie('collectedBugs', JSON.stringify(collectedBugs));
    }
}


//Let the user clear their collected bugs for developing:
//This must be registered BEFORE glitch handlers to ensure it fires first
const collectibleClearButton = document.querySelector('[data-behaviour="collectible_clear"]');
if (collectibleClearButton) {
    //Remove any glitch classes from the clear button to prevent interference
    collectibleClearButton.classList.remove('glitch--onclick', 'glitch--constantly', 'glitch--light', 'glitch--superlight');

    collectibleClearButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        console.log('Clear button clicked - reloading...');
        deleteCookie('collectedBugs');
        sessionStorage.removeItem('bugCelebrationShown');
        deleteCookie('bugTutorialShown');
        //Reload the page to show all bugs again
        location.reload();
    }, true);
}


function finishBugHunt() {
    //Show some kind of celebration when all bugs are collected
    //If there is no cookie to show the celebration only once per user session
    const celebrationShown = sessionStorage.getItem('bugCelebrationShown');
    if (celebrationShown) return;

    sessionStorage.setItem('bugCelebrationShown', 'true');

    //Simple celebration: alert
    // alert('Glückwunsch! Du hast alle Käfer gesammelt!');
    const completeModal = document.querySelector('[data-behaviour="collectible_complete_modal"]');
    if (completeModal) {
        completeModal.showModal();
    }
}


const completeModal = document.querySelector('[data-behaviour="collectible_complete_modal"]');
const completeCloseButton = document.querySelector('[data-behaviour="collectible_complete_close"]');

if(completeModal && completeCloseButton) {
    completeCloseButton.addEventListener('click', () => {
        completeModal.close();
    });
}


//If first opened, show tutorial modal
const tutorialModal = document.querySelector('[data-behaviour="collectible_tutorial_modal"]');
const tutorialButton = document.querySelector('[data-behaviour="collectible_tutorial"]');
const tutorialCloseButton = document.querySelector('[data-behaviour="collectible_tutorial_close"]');
const tutorialCloseButton2 = document.querySelector('[data-behaviour="collectible_tutorial_close2"]');

if (tutorialModal && tutorialButton && tutorialCloseButton && tutorialCloseButton2) {
    const tutorialShown = getCookie('bugTutorialShown');
    if (!tutorialShown) {
        tutorialModal.showModal();
    }

    tutorialButton.addEventListener('click', () => {
        tutorialModal.showModal();
    });

    tutorialCloseButton.addEventListener('click', () => {
        tutorialModal.close();
    });

    tutorialCloseButton2.addEventListener('click', () => {
        tutorialModal.close();
    });

    //Add event listener to set tutorial as shown
    tutorialModal.addEventListener('close', () => {
        setCookie('bugTutorialShown', 'true');
    });
}

function removeAllGlitchEffects() {
    //Remove all glitch effect classes from the page
    const glitchElements = document.querySelectorAll('.glitch--constantly, .glitch--onclick, .glitch--light, .glitch--superlight');
    glitchElements.forEach(elem => {
        //Skip if element is no longer in the DOM
        if (!elem || !elem.isConnected) {
            return;
        }

        elem.classList.remove('glitch--constantly', 'glitch--onclick', 'glitch--light', 'glitch--superlight');

        //Stop glitch effect if it exists
        const glitchInstance = PowerGlitch.glitch(elem);
        if (glitchInstance) {
            glitchInstance.stopGlitch();
        }

        //Remove event listeners from glitch--onclick elements
        const handlers = glitchEventHandlers.get(elem);
        if (handlers) {
            elem.removeEventListener('click', handlers.click, true);

            //Remove form element handlers
            handlers.formHandlers.forEach(({ elem: formElem, focus, mousedown }) => {
                formElem.removeEventListener('focus', focus);
                formElem.removeEventListener('mousedown', mousedown);
            });

            glitchEventHandlers.delete(elem);
        }
    });
}


//When you try clicking elements with the .glitch--onclick class repeatly, the tutorial should reopen
const glitchOnclickElements = document.querySelectorAll('.glitch--onclick');
let clickCounter = 0;

glitchOnclickElements.forEach(elem => {
    //Skip the clear button to allow it to function normally
    if (elem.hasAttribute('data-behaviour') && elem.getAttribute('data-behaviour') === 'collectible_clear') {
        return;
    }

    const clickHandler = (event) => {
        //Prevent other click actions and text input on those elements
        event.preventDefault();
        //event.stopPropagation();

        //Prevent input on child form elements
        if (event.target.tagName === 'INPUT' ||
            event.target.tagName === 'TEXTAREA' ||
            event.target.tagName === 'SELECT' ||
            event.target.tagName === 'BUTTON') {
            event.target.blur();
        }

        clickCounter++;
        if (clickCounter % 2 === 0) {
            tutorialModal.showModal();
            console.log('Reopening tutorial due to repeated clicks on glitch element.');
        }
    };

    elem.addEventListener('click', clickHandler, true);

    //Store handlers for later removal
    const handlers = { click: clickHandler, formHandlers: [] };

    //Also prevent form elements inside from being focused
    const formElements = elem.querySelectorAll('input, textarea, select, button');
    formElements.forEach(formElem => {
        const focusHandler = (event) => {
            event.preventDefault();
            event.target.blur();
        };
        const mousedownHandler = (event) => {
            event.preventDefault();
        };

        formElem.addEventListener('focus', focusHandler);
        formElem.addEventListener('mousedown', mousedownHandler);

        handlers.formHandlers.push({ elem: formElem, focus: focusHandler, mousedown: mousedownHandler });
    });

    glitchEventHandlers.set(elem, handlers);
});
